import type { MaybeRefOrGetter, Ref } from 'vue';
import { useOnOutsideEvent } from './useOnOutsideEvent';

/**
 * Attaches a `scroll` listener on `window` (capture, passive) and invokes
 * `callback` when the scroll event originates outside every element
 * in `excludeEls`.
 *
 * The listener is attached immediately if `isActive` already resolves to
 * `true`, follows its further changes, and is automatically removed on
 * scope disposal.
 *
 * @param callback - Called when an outside scroll is detected.
 * @param excludeEls - Scroll events that originate inside these elements are ignored.
 *                     Empty by default: every scroll triggers `callback`.
 * @param isActive - Reactive flag that drives listener lifecycle. Always active by default.
 */
export const useOnScrollDismiss = (
    callback: () => void,
    excludeEls: Ref<HTMLElement | null>[] = [],
    isActive: MaybeRefOrGetter<boolean> = true,
): void => {
    useOnOutsideEvent({
        eventTarget: window,
        eventName: 'scroll',
        callback,
        excludeEls,
        isActive,
        passive: true,
    });
};
